import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Card, Col, Container, Row, Modal, Badge, Form} from "react-bootstrap";
import {getCategoryList as onGetCategoryList} from "slices/category/thunk";
import {
    getSubMenu as onGetSubMenu,
    createSubMenu as onCreateSubMenu,
    deleteSubMenu as onDeleteSubMenu,
    updateSubMenu as onUpdateSubMenu,
} from "../../slices/submenu/thunk";
import {searchSubMenu} from "../../helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {DeleteModal} from "../../Common/DeleteModal";
import {ToastContainer} from "react-toastify";
import {useFormik} from "formik";
import * as Yup from "yup";
import {Link} from "react-router-dom";
import TableContainer from "../../Common/TableContainer";


const SubMenu = () => {
    const dispatch = useDispatch<any>();
    const categoryList = useSelector((state: any) => state.Category.categoryList);
    const subMenu = useSelector((state: any) => state.SubMenu.subMenu);
    const [listView, setListView] = useState<any>(null);
    const [show, setShow] = useState<boolean>(false);
    const [addSubMenu, setAddSubMenu] = useState<boolean>(false);
    const [deleteItem, setDeleteItem] = useState<any>(null);
    const [editModel, setEditModel] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>(null);

    useEffect(() => {
        setListView(subMenu);
    }, [subMenu]);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchSubMenu({keyword: search}, {page: 0, size: 500});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(subMenu);
        }
    };
    const handleCloseSubMenu = () => {
        setEdit(null);
        setAddSubMenu(false);
    }
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddSubMenu(true)
        setEditModel(true);
        setEdit({
            id: lastItem.id,
            subMenu: lastItem.name,
            order: lastItem.itemOrder,
            categoryId: lastItem.categoryDto?.id,
        });
        console.log(lastItem)

    }, []);

    const handleShowSubMenu = () => setAddSubMenu(true);
    const handleDeleteClose = () => setShow(false);

    //delete modal
    const deleteModalFunction = () => {
        if (deleteItem) {
            dispatch(onDeleteSubMenu(deleteItem.id));
        }
        setShow(false);
    };

    useEffect(() => {
        dispatch(onGetCategoryList());
        dispatch(onGetSubMenu())
    }, [dispatch]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },

            {
                header: "Submenu Name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Order",
                accessorKey: "itemOrder",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Category name",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <div className={""}>
                            {cell.row.original?.categoryDto?.name}
                        </div>
                    )
                }
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell.row.original)}><i
                                    className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );


    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            subMenu: (edit && edit.subMenu) || '',
            categoryId: (edit && edit.categoryId) || '',
            id: edit && edit.id,
            order: (edit && edit.order) || ''
        },

        validationSchema: Yup.object({
            subMenu: Yup.string().required("Please Enter Your Sub Menu name"),
            order: Yup.string().required("Please Enter Your Order"),
            categoryId: Yup.string().required("Please Enter Your Product Category"),
        }),

        onSubmit: (values: any) => {
            if (editModel) {
                const data: any = {
                    name: values.subMenu,
                    categoryId: values.categoryId,
                    itemOrder: values.order,
                    id: values.id
                }
                dispatch(onUpdateSubMenu(data));
                formik.resetForm();
            } else {
                const data: any = {
                    name: values.subMenu,
                    itemOrder: values.order,
                    categoryId: values.categoryId,
                }

                console.log(data);
                dispatch(onCreateSubMenu(data));
                formik.resetForm();
            }
            if (values === null) {
                handleShowSubMenu();
            } else {
                setEdit(null);
                setEditModel(false);
                handleCloseSubMenu();
            }
        }
    });

    const handleDeleteShow = (item: any) => {
        setShow(true);
        setDeleteItem(item);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row id="categoryList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Sub Menu</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search submenu..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button variant="secondary" onClick={handleShowSubMenu}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Create
                                                    SubMenu
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {listView && listView.length > 0 ? (
                                        <>
                                            <div className="vstack mb-5 gap-2">
                                                <div
                                                    className="border py-2 px-3 w-100 rounded d-flex align-items-center justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <i className="bi bi-check2-square text-primary"></i>
                                                        <ul className="d-flex align-items-center m-0"
                                                            style={{listStyleType: "none", gap: "18px"}}>
                                                            {subMenu.map((item: any, index: number) => (
                                                                <li className="mb-0" key={index}>
                                                                    <h6 className="mb-0">{item.name}</h6>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                        </>
                                    ) : (
                                        <div id="noresult">
                                            <div className="text-center py-4">
                                                <div className="avatar-md mx-auto mb-4">
                                                    <div
                                                        className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                        <i className="bi bi-search"></i>
                                                    </div>
                                                </div>
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                            </div>
                                        </div>
                                    )}
                                </Card.Body>


                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addSubMenu} onHide={handleCloseSubMenu}>
                <Modal.Header closeButton>
                    <Modal.Title>{editModel ? "update Sub Menu List" : "Add Sub Menu"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="subMenu"
                                placeholder="Submenu Name"
                                value={formik.values.subMenu}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.subMenu}
                            />
                            {formik.errors.subMenu && formik.touched.subMenu ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.subMenu}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="Customer-Name-input">Order<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="order"
                                placeholder="Order"
                                value={formik.values.order}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.order}
                            />
                            {formik.errors.order && formik.touched.order ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.order}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Label htmlFor="productCategories">
                                Categories <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                                className="form-control"
                                name="categoryId"
                                id="productCategory"
                                value={formik.values.categoryId}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.categoryId}
                            >
                                <option value={""}>Select Category</option>
                                {categoryList.content.length > 0 && categoryList.content.map((item: any, index: any) => (
                                    <option key={index} value={item.id}>{item.name}</option>
                                ))}

                            </Form.Select>
                            {formik.errors.categoryId && formik.touched.categoryId ? (
                                <Form.Control.Feedback
                                    type="invalid"> {formik.errors.categoryId} </Form.Control.Feedback>
                            ) : null}
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseSubMenu}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editModel ? "update" : "Add Model"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <ToastContainer/>
        </React.Fragment>
    )
}

export default SubMenu;